import { Drawer as AntDrawer } from 'antd';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

// icons
import { ReactComponent as IconUser } from '../../../assets/svg/drawer/drawer-account.svg';
import { ReactComponent as IconFaq } from '../../../assets/svg/drawer/drawer-faq.svg';
// import { ReactComponent as IconRules } from "../../../assets/svg/drawer/drawer-rules.svg";
// import { ReactComponent as IconAboutUS } from "../../../assets/svg/drawer/drawer-about-us.svg";
import { ReactComponent as IconLogin } from '../../../assets/svg/drawer/drawer-home.svg';
import { ReactComponent as IconLocation } from '../../../assets/svg/drawer/drawer-location.svg';
import { ReactComponent as IconLogOut } from '../../../assets/svg/drawer/drawer-logout.svg';
import { ReactComponent as IconUpdate } from '../../../assets/svg/drawer/drawer-refresh.svg';
import { ReactComponent as IconSupport } from '../../../assets/svg/drawer/drawer-support.svg';
import { version } from '../../../base/env';
import { calculator } from '../../../base/utils';
import { _Cart_Clean } from '../../../store/actions/cart_actions';
import { _logout_user } from '../../../store/actions/login_actions';
import { ReactComponent as CancelIcon } from './../../../assets/svg/cancel.svg';
import { ReactComponent as MenuIcon } from './../../../assets/svg/menu.svg';
import Item from './Item/Item';

const Drawer = ({ Login }) => {
  const History = useHistory();
  const dispatch = useDispatch();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    calculator();
  }, []);

  const _logout = () => {
    dispatch(_Cart_Clean());
    dispatch(_logout_user());
    calculator();
    if (Login.login_required) {
      History.push('/login/d');
    } else {
      History.push('/');
    }
  };

  const _resetData = () => {
    localStorage.setItem(
      'carfillo',
      `{"Cart":[],"Login": ${JSON.stringify(JSON.parse(localStorage.getItem('carfillo')).Login)}}`
    );
    localStorage.removeItem('carfillo-Version');
    caches
      .keys()
      .then((names) => {
        names.forEach((name) => caches.delete(name));
        return names;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
    window.location.reload();
  };

  const items_list = [
    {
      condition: true,
      profile: false,
      noLink: false,
      data: {
        label: `${Login?.province_name} - ${Login?.city_name ?? 'انتخاب شهر و استان'}`,
        icon: IconLocation,
        url: '/store/edit/'
      }
    },
    {
      condition: !!Login?.is_login,
      profile: true,
      noLink: false,
      data: {
        label: 'حساب کاربری',
        icon: IconUser,
        url: '/profile/'
      }
    },
    {
      condition: true,
      profile: false,
      noLink: false,
      data: {
        label: 'تماس با پشتیبانی',
        icon: IconSupport,
        url: '/support/'
      }
    },
    {
      condition: true,
      profile: false,
      noLink: false,
      data: {
        label: 'راهنما و سوالات متداول',
        icon: IconFaq,
        url: '/faq/'
      }
    },
    // {
    //   condition: true,
    //   profile: false,
    //   noLink: false,
    //   data: {
    //     label: "قوانین و مقررات",
    //     icon: IconRules,
    //     url: "/",
    //   },
    // },
    // {
    //   condition: true,
    //   profile: false,
    //   noLink: false,
    //   data: {
    //     label: "درباره ما",
    //     icon: IconAboutUS,
    //     url: "/",
    //   },
    // },
    {
      condition: true,
      profile: false,
      noLink: true,
      data: {
        label: 'راه‌اندازی دوباره',
        icon: IconUpdate,
        url: 'IconLogOut',
        onClick: () => _resetData()
      }
    },
    {
      condition: !!Login?.is_login,
      profile: false,
      noLink: true,
      data: {
        label: 'خروج از حساب کاربری',
        icon: IconLogOut,
        url: 'IconLogOut',
        onClick: () => _logout()
      }
    },
    {
      condition: !Login?.is_login,
      profile: false,
      noLink: false,
      data: {
        label: 'ورود / ثبت‌نام',
        icon: IconLogin,
        url: '/login/d/'
      }
    }
  ];

  return (
    <div>
      <button className="mobile-menu-btn" onClick={() => setVisible(true)} type="button">
        <MenuIcon className="mobile-menu-icon" />
      </button>
      <AntDrawer
        className={!visible ? 'ant-drawer-closed' : ''}
        closable={false}
        onClose={() => setVisible(false)}
        placement="right"
        visible={visible}
        width="80%"
        zIndex={9999999999}>
        <div className="drawer-main">
          <div className="drawer-header-container" onClick={() => setVisible(false)}>
            <CancelIcon className="drawer-cancel-icon" />
          </div>

          <div className="drawer-menu">
            <ul className="mt-3" style={{ width: '100%' }}>
              {items_list.map((item, i) => (
                <Item
                  key={i}
                  condition={item.condition}
                  data={item.data}
                  noLink={item.noLink}
                  profile={item.profile}
                />
              ))}
            </ul>
          </div>
          <div className="drawer-enamad-container">
            <a
              href=" https://trustseal.enamad.ir/?id=255007&Code=ARZiyzIVw913sbW1yfrPcQXC9N0UZRqH "
              referrerPolicy="origin"
              target="_blank">
              <img
                alt=""
                code="ARZiyzIVw913sbW1yfrPcQXC9N0UZRqH"
                referrerPolicy="origin"
                src=" https://trustseal.enamad.ir/logo.aspx?id=255007&Code=ARZiyzIVw913sbW1yfrPcQXC9N0UZRqH"
                style={{ cursor: 'pointer', height: '100px' }}
              />
            </a>
          </div>

          {visible ? <div className="version">{`نسخه ${version}`}</div> : null}
        </div>
      </AntDrawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

export default connect(mapStateToProps)(Drawer);
